<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-clock text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de Gestiones
        </span>
      </div>
    </div>
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em class="radius fas fa-file-invoice" />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.createdDate | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.createdDate | hour }}
              </div>
            </div>
          </template>
          <div class="row py-4 mx-3">
            <div class="col-md-12">
              <div class="row ml-3">
                <div class="col-3 ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Gestión Realizada por:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.createdBy }}
                  </div>
                </div>
                <div class="col ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Tipo de Gestión:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.procedureType }}
                  </div>
                </div>
              </div>
              <div
                class="row bg-white rounded py-2 pl-3 mt-3 ml-5 ml-md-5 ml-sm-0"
              >
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Comentario:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.comment }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
//libs
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";

//constants
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";

export default {
  name: "RequestProcedureHistory",
  components: {
    TimeLine,
    TimeLineItem
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: map-get($colors, "gray-2");
    color: map-get($colors, "white");
    box-shadow: 0px 3px 6px #00000029;
  }
}
</style>
